import React, { Component } from 'react'
import Header from '../components/Header'
import Card1 from '../components/cards/Card1'
import { connect } from 'react-redux';
import { changeStateValue } from '../redux/MainReducer';
import { getCategories, getProducts, getSubCategoriesFilter } from '../actions/MainAction';
export class ProductsPage extends Component {
  getDroopValue(arr, label, value){
    let newArr = [];
    for(const item of arr){
        newArr.push({
            label: item?.translate[label],
            value: item[value],
        })
    }
    return newArr
}
  openModal=(data, lang, lang_id=1)=>{
    if(data?.sub_category_id){
      this.props.getSubCategoriesFilter(data?.category_id)
    }else{
      this.props.changeStateValue({name:"subCategoryDataFilter", value:[]})
    }
    this.props.changeStateValue({
      name:"mainModal",
      value:{
        position:true,
        id: data?.id?data?.id:"",
        image: data?.image?data?.image:"",
        image_2: data?.image_2?data?.image_2:"",
        image_3: data?.image_3?data?.image_3:"",
        image_4: data?.image_4?data?.image_4:"",
        image_full_url: data?.image_full_url?data?.image_full_url:"",
        image_2_full_url: data?.image_2_full_url?data?.image_2_full_url:"",
        image_3_full_url: data?.image_3_full_url?data?.image_3_full_url:"",
        image_4_full_url: data?.image_4_full_url?data?.image_4_full_url:"",
        category_id: data?.category_id?data?.category_id:"",
        // sub_category_id: data?.sub_category_id?data?.sub_category_id:"",
        path: data?.path?data?.path:"",
       
        languages:
        {
            id:lang?.id?lang?.id:'',
            title:lang?.title?lang?.title:'',
            description:lang?.description?lang?.description:'',
            lang_id:lang_id
        },
        image_count:0,
        deleted_images:[],
        requiredsLang: ["title",  "description"],
        requireds:[],
        afterCallFunction:this.props.getProducts,
        afterParams:[],
        selectSub:true,
        categoryOption: this.getDroopValue(this.props.categoryData, "title", "id"),
        url:'admin-product'
      }
    })
  }

  componentDidMount(){
    this.props.getProducts();
    this.props.getCategories();
  }
  render() {
    const {productsData} = this.props;
    console.log(productsData)
    return (
      <div className='p-[40px] w-full'>
        <Header onClickBtn={this.openModal.bind(this, "", "", 1)} title="Məhsullar" />
        <div className='grid-full-250 grid grid-cols-2 mt-[20px]'>
          {
            productsData?.map((data, i)=>{
              return(
                <Card1 
                  key={i}
                  image={data?.image_full_url}
                  onChangeLang={(id)=>this.openModal(data, data.translates.find(x=>x.lang_id==id), id)} 
                  title1={data?.translate?.title}
                  deleteUrl={`admin-product/${data?.id}`}
                  afterCallFunction={()=> this.props.getProducts()}
                />
              )
            })
          }
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state)=>({
  productsData: state.Data.productsData,
  categoryData: state.Data.categoryData,
});
const mapDispatchToProps = {changeStateValue, getProducts, getCategories, getSubCategoriesFilter}
export default connect(mapStateToProps, mapDispatchToProps)(ProductsPage) 